/**
 * Created by Jason on 2017-4-17.
 */
import '../../assets/lib/boostrap/css/bootstrap.css';
import '../../assets/lib/boostrap/js/bootstrap';
import '../../assets/lib/fontawesome/css/font-awesome.min.css';
import './user-manage.less'
import Validation from '../../assets/js/validation'

import '../../assets/lib/boostrap/js/bootstrap';
import main from '../../assets/js/main';
import util from '../../assets/js/util';
;
//弹窗
import bootbox from '../../assets/lib/bootbox/bootbox';

main.ready((userData) => {
    let $userManageList = $('#user-manage-list');
    let companyId = util.getCompanyId();
    let userTypeMap = ['', '负责人', '联系人', '查看人']
    $.get(SERVER + '/companyUser/queryUserList', {
        'companyId': companyId
    }, (json) => {
        if (json.status == 0){
            let html = '';
            json.data.forEach((user) => {
                html += renderTr(user);
            });
            $userManageList.html(html);
        } else {
            location = '/index.html';
        }
    });
    function renderTr(user) {
        return `<tr><td>${user.name}</td><td>${user.phone}</td><td>${userTypeMap[user.userType]}</td>
            <td>${user.userType == 3 ? `<button data-id="${user.relationId}" type="button" data-type="del" class="btn btn-xs btn-danger">删除</button>` : '-'}</td></tr>`
    }
    let $addUser = bootbox.dialog({
        keep: true,
        title: '增加查看人',
        message: `<form class="form-horizontal add-user-box">
            <div class="form-group">
            <label for="company-name" class="col-sm-2 control-label"><span class="require">*</span>姓名</label>
            <div class="col-sm-6">
            <input type="text" maxlength="6" name="name" class="name form-control" placeholder="2-6个中文">
            </div>
            <div class="col-sm-4 form-error"></div></div>
            <div class="form-group">
            <label for="company-name" class="col-sm-2 control-label"><span class="require">*</span>手机</label>
             <div class="col-sm-6">
            <input type="text" maxlength="11" name="phone" class="phone form-control" placeholder="11位手机号">
            </div>
            <div class="col-sm-4 form-error"></div></div>
        </form>`,
        show: false,
        closeButton: false,
        buttons: {
            'no': {
                label: '取消',
                className: 'btn-danger'
            },
            'ok': {
                label: '提交',
                className: 'btn-success',
                callback() {
                    valid.validAll((status) => {
                        $.post(SERVER + '/companyUser/addCompanyUser', {
                            companyId: companyId,
                            userName: status.name.value,
                            userPhone: status.phone.value
                        }, (json) => {
                            if (json.status == 0) {
                                util.success('新增成功');
                                $addUser.modal('hide');
                                $userManageList.append(renderTr(json.data));
                            }
                        })
                    })
                    return false;
                }
            }
        }
    })
    //验证
    let valid = new Validation($addUser.find('.add-user-box'), {
        methods: {
            'name': function (value, result) {
                if (util.isName(value)) {
                    result(true);
                } else {
                    result('请填写2-6个中文姓名');
                }
            },
            'phone': function (value, result) {
                if (util.isPhone(value)) {
                    result(true);
                } else {
                    result('请填写11位数字的手机号');
                }
            }
        }
    });
    //弹窗打开
    $("#add-view-user").on('click', function () {
        valid.empty();
        $addUser.modal('show');
    });
    //删除
    $userManageList.on('click', function (e) {
        let $t = $(e.target);
        if ($t.data('type') == 'del') {
            util.confirm('确定要删除吗？', () => {
                $.post(SERVER + '/companyUser/removeCompanyUser', {
                    companyId:companyId,
                    relationId: $t.data('id')
                }, (json) => {
                    if (json.status == 0) {
                        $t.closest('tr').remove();
                    }
                })
            });
        }
    });
})


// WEBPACK FOOTER //
// ./src/pages/user-manage/user-manage.js